import { configureStore } from "@reduxjs/toolkit";
import AdminSlice from "./adminSlice";
import authorizationSlice from "./authSlice";
import EmployerSlice from "./employerSlice";
import StudentSlice from "./StudentSlice";


const store = configureStore({
    reducer: {
        auth: authorizationSlice.reducer,
        user: StudentSlice.reducer,
        admin: AdminSlice.reducer,
        employer:EmployerSlice.reducer
    }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store